import { ReactElement } from 'react';

import './index.css';

interface OptionProps {
  label: string;
  isSelected: boolean;
  handleSelect: () => void;
}

const Option: React.FC<OptionProps> = ({
  label,
  isSelected,
  handleSelect,
}: OptionProps) => {
  const containerClassName = `chart-options-item ${
    isSelected ? 'chart-options-item-selected' : ''
  }`;

  return (
    <div className={containerClassName} onClick={handleSelect}>
      <h5 className="chart-options-item-text">{label}</h5>
    </div>
  );
};

interface OptionsWrapperProps {
  children?: ReactElement | ReactElement[];
  scroll?: boolean;
}

const OptionsWrapper: React.FC<OptionsWrapperProps> = ({
  children,
  scroll,
}: OptionsWrapperProps) => {
  const className = `chart-options-wrapper ${
    scroll ? 'overflow-scroll-x' : ''
  }`;
  return <div className={className}>{children}</div>;
};

interface OptionsProps {
  children?: ReactElement | ReactElement[];
}

const ChartOptions = ({ children }: OptionsProps) => {
  return <div className="chart-options-root">{children}</div>;
};

ChartOptions.OptionsWrapper = OptionsWrapper;
ChartOptions.Option = Option;

export default ChartOptions;
